import eventsCard from "./eventsCard"
export default eventsCard;
